<template>
    <div class="success-page">
        <div class="success-page__header">
            <img src="../assets/img/ardi-logo-wh.svg" alt="" height="58">
        </div>
        <div class="success-page__content pt-5">
            <h2>მადლობას გიხდით ელექტრონული ხელმოწერისთვის!</h2>
            <br />
            <p>
                {{this.customername}} 🚗<br />
                თქვენი კომპანიის კუთვნილი ავტოპარკი დაზღვეულია.
            </p>
            <p class="mt-5">
                პოლის(ებ)ი დოკუმენტური სახით გამოიგზავნება კორპორაციულ ელ-ფოსტაზე <br />
                <a href="mailto:this.data.confPersMail">{{this.data.confPersMail}}</a>
            </p>

            <div class="mt-5 border mb-5 col-md-8 offset-md-2" style="border-radius:16px">
                <div class="d-md-flex d-lg-flex  justify-content-between m-3">
                    <div class="sm-config  mt-2">
                        <div style="font-weight:bold">დამზღვევი</div>
                        <span style="color: #007961">{{this.customername}}</span>
                    </div>
                    <div class="sm-config mt-2">
                        <div style="font-weight:bold">ხელშეკრულების ნომერი</div>
                        <span>{{this.generalnumber}}</span>
                    </div>
                </div>
            </div>

            <div class="mt-5 border mb-5 col-md-8 offset-md-2" style="border-radius:16px">
                <div class="d-md-flex d-lg-flex justify-content-between m-3">

                    <div class="d-md-flex d-lg-flex ">
                        <img :src="this.managerPhoto" height="84" class="img_rounded sm-photo">
                        <div class="pl-lg-3 pl-md-3 mt-3 sm-config">
                            თქვენი კორპორაციული მენეჯერია: <br />
                            <span style="color: #007961">{{this.managerName}}</span>
                        </div>

                    </div>
                    <div class="pr-md-5 mt-3 sm-config">
                        <img src="../assets/img/CASCO/tel-icon.png" height="20" alt=""> {{this.managerPhone}} <br />
                        <img src="../assets/img/CASCO/email-icon.png" height="18" alt=""> {{this.managerEmail}}
                    </div>
                </div>

            </div>

        </div>

        <div class="success-page__footer pl-5 pr-3 pb-4">
            <div class="d-flex justify-content-between text-md w-100">
                <div>
                    T: 2 10 10 10 <br />
                    www.ardi.ge
                </div>
                <img src="../assets/img/CASCO/success_footer_slogan.png" width="220" height="30" style="padding-right: 31px; margin-top: 10px; ">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['customername', 'rowid','generalnumber', 'cust', 'managerName', 'managerPhone', 'managerEmail','managerPhoto'],
        name: "cascosucces",
        data() {
            return {
                data: null,
                photo: this.managerPhoto,
            }
        },
        mounted() {
            this.$http.get(`/policy/GetEsignById/${this.rowid}`).then(r => {
                this.data = r.data;
                console.log("getesigninfo", r.data);
            }).catch((e) => {
                console.log(e)
            })
        },
        methods: {
            openLink: function (url) {
                window.open(url, "_blank");
            }
        }
    }
</script>




<style>


    body {
        font-family: FiraGo;
        font-size: 1rem;
    }

    .success-page {
        background-color: #fff;
    }

    .success-page__header {
        height: 100px;
        background-color: #007961;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 10px solid red;
    }

    .success-page__content h2 {
        color: #007961;
        font-size: 28px;
        font-family: inherit;
        font-weight: normal;
        text-align: center;
    }

    .success-page__content a {
        color: #007961;
    }

    .success-page__content p {
        text-align: center;
    }

    .success-page__content .img_rounded {
        border-radius: 50%;
    }

    .success-page__footer {
        background: url(../assets/img/CASCO/success-page-footer.jpg) no-repeat 50%;
        background-size: cover;
        height: 270px;
        color: azure;
        display: flex;
        align-items: end;
    }
</style>